export const LOGOUT = 'LOGOUT';
export const REFRESH_COOKIE = 'REFRESH_COOKIE';
